export const COMPLETE_TRIAL_DAYS = 15;
export const COMPLETE_LOOKUP_KEY = 'advanced_monthly';
export function offeredLookup(virada: boolean, lookup: string) {
  return virada ? COMPLETE_LOOKUP_KEY : lookup;
}
export function isHiddenTool(slug: string) {
  return /iarisco|geracao-com-ia|trico/i.test(slug);
}
export function completeAccountState(input: { paid: boolean; trial: boolean; participant?: string | null }) {
  if (input.trial) return 'Em trial';
  if (input.paid) return 'Assinante';
  if (input.participant === 'ativa') return 'Participante da campanha';
  return 'Bloqueado';
}